import { useState } from "react";
import { FaShapes } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import {
  InstallationPickerOption,
  InstallationPickerRow,
  InstallationPickerSheet,
} from "../installation/InstallationPickerSheet";

const NotificationMaterialPicker = ({
  materialList,
  materialToDisplay,
  onSelect,
  embedded = false,
}) => {
  const { t } = useTranslation();
  const [sheetOpen, setSheetOpen] = useState(false);
  const selectedMaterial = materialToDisplay[0];
  const placeholder = t("mobile_notifications_material_placeholder");

  const handleSelect = (material) => {
    onSelect([material]);
    setSheetOpen(false);
  };

  const row = (
    <InstallationPickerRow
      icon={FaShapes}
      title={placeholder}
      subtitle={selectedMaterial?.nameAndCount}
      placeholder={placeholder}
      onClick={() => setSheetOpen(true)}
    />
  );

  return (
    <>
      {embedded ? (
        row
      ) : (
        <div className="installation-settings-card notification-material-picker-card">
          {row}
        </div>
      )}

      <InstallationPickerSheet
        open={sheetOpen}
        title={t("mobile_notifications_material_sheet_title")}
        onDismiss={() => setSheetOpen(false)}
      >
        {materialList.map((material) => (
          <InstallationPickerOption
            key={material.value}
            label={material.nameAndCount}
            selected={selectedMaterial?.value === material.value}
            onSelect={() => handleSelect(material)}
          />
        ))}
      </InstallationPickerSheet>
    </>
  );
};

export default NotificationMaterialPicker;
